<section class="curation-editor-wrapper curation-editor-wrapper-report" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [publishUserMode]="publishUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [oldRevisionIsShown]="oldRevisionIsShown"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [revisedRelatedEntities]="revisedRelatedEntities"
    [revisiedEntitiesTableData]="revisiedEntitiesTableData"
    [nodesWithNotes]="nodesWithNotes"
    [showPreviewButton]= "getShowPreviewButton()"
    [sameOrganization]= "sameOrganization"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (linkClickedEvent)="nodeLinkClicked($event)"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack()"
    (notesPanelToggled)="toggleNotesPanel('Notes - General')"
    (runPreview)="startPreview()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [showStopWorkflowButton] = "showStopWorkflowButton"
    [showArchiveReason] = "showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
          name="CURATION-NOTES-PANEL"
          class="{{notesPanelClass}}"
          (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>


  <section class="scrollable curation-editor-content-and-viewer">

    <div *ngIf="!showTreeViewContainer && showApproveContainer" class="model-approval-icon-container"
         [ngClass]="{'positionInApproveMode': approvedMode || pendingForApproval}">
      <i class="icon__Document model-approval-icons-24" (click)="openModelApprovalPanel()">
      </i>
    </div>

    <div *ngIf="showTreeViewContainer" class="tree-view-icon-container" id="treeViewIconContainer">
      <div *ngIf="showApproveContainer" class="view-model-approval-icon-container">
        <i class="icon__Document tree-view-icons-24" (click)="openModelApprovalPanel()"
        ></i>
      </div>
      <div class="view-tree-icon-container"  [ngClass]=" explorerViewIsVisible ? 'explorer-view-opened': 'explorer-view-closed'">
        <i [ngClass]="explorerViewIsVisible ?'explorerview__icon__DLS_NetworkConnection_24': 'explorerview__icon__DLS_NetworkConnection_24_grey'"
            class="tree-view-icons-24"
           (click)="openTreeViewerPanel()"></i>
      </div>
    </div>

    <gen-panel class="model-approval-panel" [name]="bpmnApprovalPanel"
               [position]="bpmnApprovalPanelPosition"></gen-panel>
    <!-- ngSwitch in this case is used for forced initialization of ispm-modeler with any state change -->
    <section ng-if="isWithReport" class="pathways-creator-container">
      <gen-panel *ngIf="showTreeViewContainer" class="tree-view-panel" [name]="bpmnTreeViewPanel"
                 [position]="bpmnTreeViewPanelPosition"
                 [panelId]="'explorerView'"
                 (toggleDisplayStatusChanged)="explorerViewDisplayStatusChanged($event)"
                 [fullHeight]="true"></gen-panel>
      <ispm-modeler *ngIf="visible" [headNodeName]="pathwayBpmnName"
                    [data]="curationItem.curationData.content.bpmn"
                    [knowledgeBase]="getDbName()"
                    [config]="bpmnModelerCfg" [state]="bpmnState" [performTreeRepair]="performTreeRepair"
                    [revisedEntitiesRevisionsData]="revisedEntitiesRevisionsData"
                    [hideBpmnLogo]="hideBpmnLogo"
                    [discipline]="discipline"
                    (modelerRendered)="onModelerRender($event)"
                    (nodeSelected)="onNodeSelected($event)"
                    (toggleRightPanel)="onRightPanelOpened($event)"
      ></ispm-modeler>
    </section>
  </section>
</section>

<gen-dynamic-modal-loader [observableName]="'DYNAMIC_MODAL_LOADER2'"></gen-dynamic-modal-loader>
